/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type child_extras_UpdateChildExtraRequest = {
    amountCents?: number;
    internalComment?: string;
    parentComment?: string;
    serviceDate?: string;
    type?: child_extras_UpdateChildExtraRequest.type;
};
export namespace child_extras_UpdateChildExtraRequest {
    export enum type {
        EINSCH = 'EINSCH',
        EMPFEHL = 'EMPFEHL',
        MISC = 'MISC',
        LEGACY = 'LEGACY',
        SETTLING_IN = 'SETTLING_IN',
        TERMINATION = 'TERMINATION',
    }
}

